const createUserFormFields = [
  { label: 'Name', key: 'name', type: 'text', isRequired: true },
  { label: 'Email', key: 'email', type: 'email', isRequired: true },
];

export { createUserFormFields };
